import { BlockLayouts } from '@/types/gql.generated';

export const GROUP_BY_OPTIONS = [
  { id: BlockLayouts.ListByEvent, label: 'Item' },
  { id: BlockLayouts.ListByDay, label: 'Day' },
  { id: BlockLayouts.ListByWeek, label: 'Week' },
  { id: BlockLayouts.ListByMonth, label: 'Month' },
  { id: BlockLayouts.ListByYear, label: 'Year' },
];

export const getGroupByOptions = (layouts: string[]) =>
  GROUP_BY_OPTIONS.filter((o) => layouts.includes(o.id));
